import React from 'react'
import {Button, Card, Flex, Text} from '@sanity/ui'
import {BoltIcon} from '@sanity/icons'
import {purple} from '@sanity/color'
import {AppLink} from '../../app/appLink'
import {useManageScheme} from '../../app/manageSchemeProvider'

type EnterpriseUpsellBannerProps = {
  children: React.ReactNode
  salesRef?: string
}

export function EnterpriseUpsellBanner({
  children,
  salesRef = 'manage',
}: EnterpriseUpsellBannerProps) {
  const {resolvedScheme} = useManageScheme()
  const isDark = resolvedScheme === 'dark'

  return (
    <Card tone="neutral" padding={3} border radius={2}>
      <Flex gap={4} align="center" justify="space-between" wrap="wrap">
        <Flex flex={1} align="center" gap={2}>
          <BoltIcon
            style={{
              color: isDark ? purple['400'].hex : purple['600'].hex,
              height: '25px',
              width: '25px',
            }}
          />
          {children}
        </Flex>
        <AppLink href={`/contact/sales?ref=${salesRef}`}>
          <Button tone="default" padding={2}>
            <Text>Contact Sales</Text>
          </Button>
        </AppLink>
      </Flex>
    </Card>
  )
}
